import { render, staticRenderFns } from "./ms.vue?vue&type=template&id=41f1d8d0&scoped=true&"
import script from "./ms.vue?vue&type=script&lang=js&"
export * from "./ms.vue?vue&type=script&lang=js&"
import style0 from "./ms.vue?vue&type=style&index=0&id=41f1d8d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f1d8d0",
  null
  
)

export default component.exports